import { AxiosPromise } from 'axios';

import { IVaporIO } from '../../interfaces';
import { post } from '../../lib';

declare const vaporio: IVaporIO;
const host = vaporio.api;

export function postLogin(idToken: string): Promise<AxiosPromise> {
	return post(`${host}/login`, {
		data: {},
		headers: {
			// eslint-disable-next-line @typescript-eslint/naming-convention
			Authorization: `Bearer ${idToken}`
		}
	}, false);  // false for retry
}

export function postLogout(): Promise<AxiosPromise> {
	return post(`${host}/logout`, {
		data: {}
	}, false);  // false for retry
}
